module.exports = __webpack_public_path__ + "static/media/M005-noprivilege.19369f2f.svg";